import Content from '../content-interface'
import Validity from '../validity.entity';

export default class RulePausedHistory implements Content {
  justification: string;

  observation: string

  validity: Validity

  constructor(obj: any = {}) {
    this.justification = obj.justification || '';
    this.observation = obj.observation || '';
    this.validity = Validity.of(obj.validity) || {};
  }

  public static of(obj: any = {}): RulePausedHistory {
    return new RulePausedHistory(obj);
  }
}
